import React from "react";
import axios from "axios";
import {
    Link
} from "react-router-dom";
import {
    Alert,
    Table
} from "react-bootstrap";
import {
    Title
} from "@zandor300/backoffice-framework";

import ShopsContext from "../../context/ShopsContext";
import Loading from "../../components/Loading";
import TagPill from "../../components/pills/TagPill";

class Collections extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            collections: null,
            error: null
        }
    }

    componentDidMount() {
        this.getCollections();
    }

    getCollections() {
        this.setState({ collections: null, error: null });
        axios.post("/getCollections", { shopId: this.context.currentShop.id })
            .then((response) => {
                if(response.data.valid) {
                    const collections = response.data.collections.sort((collection1, collection2) => {
                        return collection1.name > collection2.name ? 1 : -1;
                    });
                    this.setState({ collections });
                } else {
                    this.setState({ error: "Er ging iets fout. Probeer het later opnieuw." });
                }
            })
            .catch(() => {
                this.setState({ error: "Er ging iets fout. Probeer het later opnieuw." });
            });
    }

    render() {
        const baseUrl = "/shop/" + this.context.currentShop.codeName;
        return (
            <React.Fragment>
                <Title
                    preTitle="Overzicht"
                    // preChildren={
                    //     <div className="float-right mt-2">
                    //         <OverlayTrigger overlay={
                    //             <Tooltip id="newProduct">Nieuwe collectie</Tooltip>
                    //         }>
                    //             <Link
                    //                 to={ baseUrl + "/collections/add" }
                    //                 className="btn btn-secondary float-right mt-2"
                    //             >
                    //                 <i className="fas fa-fw fa-plus"/>
                    //             </Link>
                    //         </OverlayTrigger>
                    //     </div>
                    // }
                >
                    Collecties
                    <small>
                        <TagPill className="ml-2">{ this.state.collections ? this.state.collections.length : 0 }</TagPill>
                    </small>
                </Title>
                <Table size="sm" className="results" hover={ this.state.collections && this.state.collections.length > 0 }>
                    <thead className="thead-light">
                    <tr>
                        <th className="text-center">#</th>
                        <th className="text-left">Naam</th>
                        <th className="text-right">Aantal producten</th>
                        <th className="text-left">Interne naam</th>
                    </tr>
                    </thead>
                    <tbody>
                    { this.state.error ? (
                        <tr>
                            <td colSpan={ 5 }>
                                <Alert variant="danger" className="mb-0">{ this.state.error }</Alert>
                            </td>
                        </tr>
                    ) : this.state.collections === null ? (
                        <tr>
                            <td colSpan={ 5 }>
                                <Loading/>
                            </td>
                        </tr>
                    ) : this.state.collections.length === 0 ? (
                        <tr>
                            <td colSpan={ 5 } className="text-center">
                                <h1><i className="fas fa-th-list"/></h1>
                                <h4>Geen collecties</h4>
                                <p>Er staan nog geen collecties in de shop.</p>
                            </td>
                        </tr>
                    ) : this.state.collections.map((collection) => {
                        const url = baseUrl + "/collection/" + collection.id;
                        return (
                            <tr key={ collection.id } className="table-clickable-row">
                                <th scope="row" className="align-middle text-center">
                                    <Link to={ url }>
                                        { collection.id }
                                    </Link>
                                </th>
                                <td className="align-middle">
                                    <Link to={ url }>
                                        { collection.name }
                                    </Link>
                                </td>
                                <td className="align-middle text-right">
                                    <Link to={ url }>
                                        { collection.products ? collection.products.length : 0 }
                                    </Link>
                                </td>
                                <td className="align-middle">
                                    <Link to={ url }>
                                        { collection.codeName }
                                    </Link>
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </Table>
            </React.Fragment>
        )
    }
}
Collections.contextType = ShopsContext;

export default Collections;
